import React from 'react';
import { compose, omit, prop } from 'ramda';
import { branch, defaultProps, renderComponent } from 'recompose';

import connect from 'app/libs/connect';
import RegisterRedirect from 'app/router/RegisterRedirect';
import { isUserAnonymous } from 'app/features/user/selectors';
import { selectedSkuReset } from 'app/features/products/actions';
import withDispatchOnMount from 'app/enhancers/withDispatchOnMount';
import { NEXT, PRICING_PROMO_LANDING_PATH } from 'app/router/constants/paths';
import HeroBlock from 'app/features/pricingPromo/landing/components/heroBlock';
import MegaFanPerks from 'app/features/pricingPromo/landing/components/megaFanPerks';

const UI = () => (
  <>
    <HeroBlock />
    <MegaFanPerks />
  </>
);

UI.displayName = 'Pricing Promo Landing page';

const RegisterRedirectWithNext = compose(
  defaultProps({ [NEXT]: PRICING_PROMO_LANDING_PATH }),
  renderComponent(RegisterRedirect),
  omit([NEXT]),
);

const PricingPromo = compose(
  withDispatchOnMount(selectedSkuReset),
  connect({ isUserAnonymous }),
  branch(prop('isUserAnonymous'), RegisterRedirectWithNext),
)(UI);

export { UI };

export default PricingPromo;
